import { useLoaderData } from "react-router";
import { api } from "@/lib/api";
import HomepageLayout from "@/layouts/HomepageLayout";
import RubsView from "@/components/RubsView";

import type { RubWithSurah } from "@/lib/types";

export const homeLoader = () => api<RubWithSurah[]>("/api/rubs?v=2");

export default function Home() {
	const rubs = useLoaderData<RubWithSurah[]>();

	return (
		<HomepageLayout>
			<RubsView rubs={rubs} />
		</HomepageLayout>
	);
}
